import { z } from 'zod';
import { configFromEnv } from '@utils/config';

const env = {
  node: configFromEnv.asEnum("NODE_ENV", {
    values: ["production", "development"],
    defaultValue: "development"
  }),
  app: configFromEnv.asEnum("APP_ENV", {
    values: ["production", "staging", "test", "feature"],
    defaultValue: "test"
  }),
  version: configFromEnv.asString("APP_VERSION", {
    schema: z.string().optional()
  })
};
const configRefs = {
  env,
  gateway: {
    lib: configFromEnv.asString("GATEWAY_LIB"),
    url: configFromEnv.asString("GATEWAY_URL"),
    appId: configFromEnv.asString("GATEWAY_APP_ID"),
    appSecret: configFromEnv.asString("GATEWAY_APP_SECRET")
  },
  apis: {
    clickstream: configFromEnv.asString("CLICKSTREAM_API"),
    componentFramework: configFromEnv.asString("COMPONENT_FRAMEWORK_API"),
    gas: configFromEnv.asString("GAS_API"),
    ibog4: configFromEnv.asString("IBOG4_API"),
    loginConnector: configFromEnv.asString("LOGIN_CONNECTOR_API"),
    mediaLibrary: configFromEnv.asString("MEDIA_LIBRARY_API"),
    opgavekomplekset: configFromEnv.asString("OPGAVEKOMPLEKSET_API"),
    papi: configFromEnv.asString("PAPI_API"),
    status: configFromEnv.asString("STATUS_API"),
    userdata: configFromEnv.asString("USERDATA_API"),
    video23: {
      video: configFromEnv.asString("VIDEO23_VIDEO_API"),
      audio: configFromEnv.asString("VIDEO23_AUDIO_API"),
      picker: configFromEnv.asString("VIDEO23_PICKER_API"),
      secret: configFromEnv.asString(
        `VIDEO23_PICKER__SECRET__${env.app.dangerouslyAssertSyncValue().toUpperCase()}`,
        {
          schema: z.string().optional()
        }
      )
    },
    pm2: {
      url: configFromEnv.asString("PM2_API"),
      preview: configFromEnv.asString("PM2_PREVIEW_API"),
      media: configFromEnv.asString("PM2_MEDIA_DOMAIN")
    }
  },
  urls: {
    courses: configFromEnv.asString("COURSES_URL"),
    gEditor: configFromEnv.asString("GEDITOR_URL"),
    gExport: configFromEnv.asString("GEXPORT_URL"),
    gLightbox: configFromEnv.asString("GLIGHTBOX_URL"),
    gNotebook: configFromEnv.asString("GNOTEBOOK_URL"),
    gPanels: configFromEnv.asString("GPANELS_URL"),
    gPolly: configFromEnv.asString("GPOLLY_URL"),
    gu: configFromEnv.asString("GU_URL"),
    ibog4: configFromEnv.asString("IBOG4_URL"),
    mitGyldendal: configFromEnv.asString("MG_URL")
  }
};

export { configRefs };
//# sourceMappingURL=config.js.map
